<template>
    <div class="main-box">
        <div class="info-box" >
            <div class="info-content" style="height: 100%;"  :class="{kechengShixun:isKecheng}">
                <div class="info-tabs-content" :style="widthStyle">
                    <div class="tabs-box" v-if="tabs.length && !isKecheng">
                        <div class="tab-item-group">
                            <div class="tab-item" :class="index === key ? 'active': ''" v-for="(item, key) in tabs"
                                 :key="key" @click="activeIndex(key)">
                                <span>{{item}}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 课程tab -->
                    <div class="tabs-box" v-if="isKecheng">
                        <div class="tab-item-group">
                            <div 
                                class="tab-item" 
                                :class="kechengKey === item.key ? 'active' :''"
                                v-for="(item, index) in kechengTabs"
                                :key="item.key"
                                @click="handleTabItem(item.key, index)"
                            >
                                <span>{{ item.label }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="project-info-body" v-if="index === 0 || (isKecheng && kechengKey === 'projectDetail')">
                        <div class="project-header-main">
                            <div class="project-header-bg"></div>
                            <div class="project-header-content">
                                <div class="header-title">
                                    <h1>{{project.project_title}}</h1>
                                </div>
                                <div class="header-duration-box"  style="margin-top:78px !important;">
                                    <div class="bg-ellipse-box" >
                                        <div class="bg-ellipse-dot dot-left"></div>
                                        <div class="bg-ellipse-dot dot-right"></div>
                                        <div class="ellipse-text">
                                            <span>建议时长：{{duration}}min</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- 实训按钮 -->
                            <div 
                                class="project-header-operate" 
                                v-if="project.training_data_type !== 0"
                            >
                                <el-button class="begin-button" size="small" @click="handleBeginTraining">开始实训</el-button>
                                <el-button class="end-button" size="small" v-if="role !== 4" @click="trainOver">结束实训</el-button>
                            </div>
                        </div>
                        <div class="info-sub-item">
                            <div class="sub-item-box" v-for="(item, index) in project.project_attrs" :key="index"
                                 v-if="item.value">
                                <div class="sub-item-title-box">
                                    <div class="s-item-title-center">
                                        <div class="header-duration-box medium-size">
                                            <div class="bg-ellipse-box blue-b">
                                                <div class="bg-ellipse-dot dot-left"></div>
                                                <div class="bg-ellipse-dot dot-right"></div>
                                                <div class="ellipse-text auto-width">
                                                    <span>{{item.name}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-item-content">
                                    <div class="text-content">
                                        <p>{{item.value}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="sub-item-box" v-if="project.project_sucai && project.project_sucai.length">
                                <div class="sub-item-title-box">
                                    <div class="s-item-title-center">
                                        <div class="header-duration-box medium-size">
                                            <div class="bg-ellipse-box blue-b">
                                                <div class="bg-ellipse-dot dot-left"></div>
                                                <div class="bg-ellipse-dot dot-right"></div>
                                                <div class="ellipse-text auto-width">
                                                    <span>素材下载</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-item-content">
                                    <div class="sucai-links-content">
                                        <div class="sucai-link-item" v-for="(item, index) in project.project_sucai"
                                             :key="index">
                                            <span class="sucai-icon"><i class="el-icon-document"></i></span>
                                            <span class="file-name">{{item.file_name}}</span>
                                            <a class="download-btn" target="_blank" :href="item.file_path"><i
                                                    class="el-icon-download" :download="item.file_name"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sub-item-box" v-if="app_lists.length">
                                <div class="sub-item-title-box">
                                    <div class="s-item-title-center">
                                        <div class="header-duration-box medium-size">
                                            <div class="bg-ellipse-box blue-b">
                                                <div class="bg-ellipse-dot dot-left"></div>
                                                <div class="bg-ellipse-dot dot-right"></div>
                                                <div class="ellipse-text auto-width">
                                                    <span>应用中心</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-item-content">
                                    <div class="app-list-box">
                                        <a :href="item.home_link" target="_blank" v-for="(item, index) in app_lists"
                                           :key="index">
                                            <div class="app-item">
                                                <div class="app-cover">
                                                    <img :src="item.logo" :alt="item.logo">
                                                </div>
                                                <div class="app-name">
                                                    <span>{{item.app_name}}</span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="sub-item-box">
                                <div class="sub-item-title-box">
                                    <div class="s-item-title-center">
                                        <div class="header-duration-box medium-size">
                                            <div class="bg-ellipse-box blue-b">
                                                <div class="bg-ellipse-dot dot-left"></div>
                                                <div class="bg-ellipse-dot dot-right"></div>
                                                <div class="ellipse-text auto-width">
                                                    <span>{{project.project_task.name}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-item-content">
                                    <div class="text-content">
                                        <p v-html="project.project_task.value"></p>
                                    </div>
                                </div>
                            </div>

                            <!-- 答案解析 -->
                            <!-- <div class="sub-item-box" v-if="role === 3 && project.answer_analysis && project.answer_analysis.name">
                                <div class="sub-item-title-box">
                                    <div class="s-item-title-center">
                                        <div class="header-duration-box medium-size">
                                            <div class="bg-ellipse-box blue-b">
                                                <div class="bg-ellipse-dot dot-left"></div>
                                                <div class="bg-ellipse-dot dot-right"></div>
                                                <div class="ellipse-text auto-width">
                                                    <span>{{project.answer_analysis.name}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-item-content">
                                    <div class="text-content">
                                        <p v-html="project.answer_analysis.value"></p>
                                    </div>
                                </div>
                            </div> -->

                            <div class="sub-item-box">
                                <div class="sub-item-title-box">
                                    <div class="s-item-title-center">
                                        <div class="header-duration-box medium-size">
                                            <div class="bg-ellipse-box blue-b">
                                                <div class="bg-ellipse-dot dot-left"></div>
                                                <div class="bg-ellipse-dot dot-right"></div>
                                                <div class="ellipse-text auto-width">
                                                    <span>项目评价</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-item-content" style="padding: 50px 0;">
                                    <el-table :data="project.project_evaluate" style="width:100%;"
                                              header-row-class-name="eval-header" stripe>
                                        <el-table-column prop="index" label="序号" align="center"
                                                         width="66px"></el-table-column>
                                        <el-table-column prop="content" label="内容" align="center"
                                                         width="200px"></el-table-column>
                                        <el-table-column prop="evaluate" label="要求" align="center"></el-table-column>
                                        <el-table-column prop="score" class-name="last-th" label="分值" align="center"
                                                         width="66px"></el-table-column>
                                    </el-table>
                                </div>
                            </div>

                        <!--------------------------------------------------------------------  -->
                        <!-- <div class="sub-item-box" v-if=" project.training_data_type !== 0 &&role === 4"> -->
                                <!-- <div class="sub-item-title-box">
                                    <div class="s-item-title-center">
                                        <div class="header-duration-box medium-size">
                                            <div class="bg-ellipse-box blue-b">
                                                <div class="bg-ellipse-dot dot-left"></div>
                                                <div class="bg-ellipse-dot dot-right"></div>
                                                <div class="ellipse-text auto-width">
                                                    <span>任务提交</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- <div class="sub-item-content" style="padding: 50px 0;"> -->
                                    <!-- <div class="task-submit"> -->
                                        <!-- 上传文件 -->
                                        <!-- <div class="task-submit_upload"> -->
                                            <!-- <div class="upload-label">请上传文件</div> -->
<!-- 
                                            <el-upload
                                                class="upload-demo"
                                                ref="uploadRef"
                                                action="#"
                                                :on-change="trainFileChange"
                                                :auto-upload="false"
                                                :show-file-list="false"
                                            >
                                                <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
                                                <div slot="tip" class="el-upload__tip">
                                                    <i class="el-icon-warning-outline"></i>
                                                    文件限制100M以内,可上传多个,支持扩展名: rar、zip、doc、docx、xls、xlsx、pdf、jpg、png -->
                                                    <!-- 文件限制100M以内,可上传多个,支持扩展名: rar、zip、docx、xlsx、pdf、jpg、png -->
                                                <!-- </div> -->
                                            <!-- </el-upload> -->

                                            <!-- <div class="upload-list">
                                                <div class="upload-file-item" v-for="[key, value] of trainFileMap" :key="key">
                                                    <img :src="getFileIcon(value.requestData.name)" alt="" />
                                                    <div class="upload-file-item_name">{{ value.requestData.name }}</div>
                                                    <i
                                                        class="upload-file-item_delete el-icon-circle-close"
                                                        @click="deleteSubmitFile(value)"
                                                    ></i>
                                                </div>
                                            </div> -->
                                        <!-- </div> -->

                                        <!-- 答题编辑 -->
                                        <!-- <div class="task-submit_editor">
                                            <editor :content="trainContent" :height="400"  @change="updateContent" ref="submitEditorRef" />
                                        </div> -->

                                        <!-- 提交 -->
                                        <!-- <div class="task-submit_operate">
                                            <el-button slot="trigger" size="small" type="primary" @click="submitTrain">提交</el-button>
                                        </div> -->
                                    <!-- </div> -->
                                <!-- </div> -->
                            <!-- </div> -->
                        <!-- ------------------------------------------------------------------------ -->

                            <div class="sub-item-box" v-if="project.project_ability">
                                <div class="sub-item-title-box">
                                    <div class="s-item-title-center">
                                        <div class="header-duration-box medium-size">
                                            <div class="bg-ellipse-box blue-b">
                                                <div class="bg-ellipse-dot dot-left"></div>
                                                <div class="bg-ellipse-dot dot-right"></div>
                                                <div class="ellipse-text auto-width">
                                                    <span>能力拓展</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-item-content">
                                    <div class="text-content">
                                        <p>
                                            {{project.project_ability}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <slot name="extender"></slot>
                        </div>
                    </div>

                    <!-- 技能评价 -->
                    <div class="skill-accessment" v-if="index === 1 && isKecheng && kechengKey === 'skillAssessment'">
                        <SkillAssessment 
                            ref="skillAssessmentRef" 
                            :analysis="(project.answer_analysis && project.answer_analysis.name) ? project.answer_analysis : {}"
                        ></SkillAssessment>
                    </div>

                    <template v-if="index === 1 && !isKecheng">
                        <div class="project-extend">
                            <el-scrollbar style="height: 100%">
                                <slot name="extend"></slot>
                            </el-scrollbar>
                        </div>
                    </template>
                </div>
                <div class="info-fix-links" v-if="index === 0">
                    <div class="fix-links-header">
                        <!-- <div class="links-head-txt"> -->
                            <!-- <span class="bottom-link"></span> -->
                           知识链接
                        <!-- </div> -->
                    </div>
                    <div class="fix-links-lists">
                        <div class="link-item-box" v-if="project.project_knowledge_link.length == 0">
                            <div class="no-link-item-content">
                                <img src='@/assets/images/project/no_link.png' class="no-link" alt="">
                                <span class="no-link-title">暂无知识链接</span>
                            </div>
                        </div>
                        <el-scrollbar style="height: 100%;" v-else>
                            <div class="link-item-box" v-for="(item, index) in project.project_knowledge_link"
                                 :key="index">
                                <a :href="item.url" target="_blank">
                                    <div class="link-item-content">
                                        <span class="link-icon" :class="typeClass(item.name, item.type)"></span>
                                        <span class="link-title">{{item.name}}</span>
                                    </div>
                                </a>
                            </div>
                        </el-scrollbar>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ResourceDialog from "../teacherCourse/component/ResourceDialog";
    import SkillAssessment from '../qualityCourse/SkillAssessment.vue';
    import Editor from "@/components/utils/Editor.vue";

    export default {
        name: "teacherProjectDetail",
        props: ['projectId', 'platform'],
        components: {
            ResourceDialog,
            SkillAssessment,
            Editor,
        },
        created() {
            this.id=this.$route.query.id
            this.projectInfo();
            console.log(this.$route);
            if(this.$route.path=='/qualityCourse/teacher/teacherCourseWareDetail' || this.$route.path== '/qualityCourse/featureddetail'){
                this.isKecheng=true
            }
            // console.log(this.isKecheng,"this.isKecheng");

            this.getTrainDetail();
        },
        computed: {
            widthStyle() {
                if (this.index === 0) {
                    return 'width: 890px; height: 100%';
                }
                return 'width: 100%';
            },
            duration() {
                return Number(this.project.project_duration) * 45;
            },
            http() {
                switch (this.platform) {
                    case 1:
                        return this.$http;
                        break;
                    case 2:
                        return this.$thttp;
                        break;
                    case 3:
                        return this.$shttp;
                        break;
                    default:
                        return this.$http;
                        break;
                }
            },
        },
        data() {
            return {
                isKecheng:false,
                id: this.$route.query.id ? Number(this.$route.query.id) : 0,
                tabs: [
                    '项目详情',
                ],
                kechengTabs: [
                    { key: "projectDetail", label: "项目详情" },
                    { key: "skillAssessment", label: "技能评价" }
                ],
                kechengKey: "projectDetail",
                project: {
                    project_title: '',
                    project_ability: [],
                    project_attrs: [],
                    project_evaluate: [],
                    project_knowledge_link: [],
                    project_sucai: [],
                    project_task: [],
                    project_duration: 0,
                    project_difficulty: 0
                },
                app_lists: [],
                index: 0,
                role: Number(localStorage.getItem("role")),
                trainFileMap: new Map(), // 学生答题上传文件
                trainContent: "", // 学生答题内容
                trainStatus: 0, // 实训状态
                trainSubmitStatus: 0, // 提交状态
            }
        },
        watch:{
            '$route.query.id'(newValue,old){
                console.log(newValue,"pppp");
                this.id=newValue
                this.projectInfo()

                // 将实训状态和提交状态重置
                this.trainStatus = 0;
                this.trainSubmitStatus = 0;
                this.getTrainDetail();

                if (this.$refs.skillAssessmentRef) {
                    this.$refs.skillAssessmentRef.getSkillAssessmentList();
                }
            }
        },
        methods: {
            backToList() {
                this.$emit('backToList', false)
            },
            activeIndex(index) {
                this.index = Number(index);
            },
            handleTabItem(key, index) {
                this.kechengKey = key;
                this.index = Number(index);
            },
            projectInfo() {
                this.http.axiosGetBy(this.$api.getProjectDetail, {id: this.id}, (res) => {
                    if (res.code === 200) {
                        console.log(res.data);
                        this.project = Object.assign({}, res.data);
                        this.app_lists = [].concat(res.data.app_lists);
                        console.log(this.project);
                    }
                }, (err) => {
                    this.$common.axiosErrorMsg(err)
                })
            },
            typeClass(name, type) {
                if (Number(type) === 7) {
                    return 'animation-link';
                }
                let tmp_array = name.split(".");
                let ext = tmp_array[tmp_array.length - 1];
                let classname = '';
                switch (ext) {
                    case 'docx':
                        classname = 'textbook';
                        break;
                    case 'ppt':
                        classname = 'coureware';
                        break;
                    case 'mp4':
                        classname = 'micro-lesson';
                        break;
                    case 'pdf':
                        classname = 'person-resource';
                        break;
                    default:
                        break;
                }
                return classname;
            },

            updateContent(val) {
                this.trainContent = val
            },

            // 结束实训
            trainOver() {
                // 实训状态：0=未结束，1=已结束
                if (this.trainStatus === 1) {
                    this.$message.success("所有学生实训已结束");
                    return;
                }

                this.$confirm("确定后将结束本章所有学生实训，是否确认？", "结束实训", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    const params = {
                        course_id: Number(this.$route.query.course_id),
                        course_chapter: Number(this.$route.query.zhangIndex),
                        course_node: Number(this.$route.query.jieIndex),
                        c_id: Number(localStorage.getItem("class_id")),
                        project_id: Number(this.$route.query.id),
                    };
    
                    this.$shttp.axiosPost(this.$api.training_end, params, (res) => {
                        if (res.code === 200) {
                            this.$message.success(res.msg);
                            this.trainStatus = 1;
                        }
                    });
                });
            },

            // 获取学生实训详情
            getTrainDetail() {
                // if (this.role === 4) {
                //     // 学生-请求列表数据获取是否提交状态
                //     const params = {
                //         course_id: Number(this.$route.query.course_id),
                //         course_chapter: Number(this.$route.query.zhangIndex),
                //         course_node: Number(this.$route.query.jieIndex),
                //         project_id: Number(this.$route.query.id),
                //         page: 1,
                //         limit: 10,
                //     };

                //     this.$shttp.axiosGetBy(this.$api.training_assessment_list, params, (res) => {
                //         if (res.code === 200) {
                //             if (res.data.list?.length > 0) {
                //                 const assessmentData = res.data.list[0];
                //                 this.trainSubmitStatus = assessmentData.status; // 提交状态
                //             }
                //         }
                //     });
                // } 
                
                // 获取实训详情
                const params = {
                    course_id: Number(this.$route.query.course_id),
                    course_chapter: Number(this.$route.query.zhangIndex),
                    course_node: Number(this.$route.query.jieIndex),
                    project_id: Number(this.$route.query.id),
                };
                if (this.role !== 4) params.c_id = Number(localStorage.getItem("class_id"));

                this.$shttp.axiosGetBy(this.$api.training_detail, params, (res) => {
                    if (res.code === 200) {
                        this.trainStatus = res.data.status; // 实训状态

                        // 初始化文件列表和输入内容数据
                        this.trainFileMap.clear();
                        this.trainContent = "";

                        if (this.role === 4) {
                            // 学生，赋值答题参数
                            this.trainContent = res.data.content;
                            this.trainSubmitStatus = res.data.student_status; // 学生提交状态

                            res.data.file?.forEach((fileItem) => {
                                this.trainFileMap.set(fileItem.url, {
                                    requestData: {  
                                        url: fileItem.url,
                                        name: fileItem.name,
                                        size: fileItem.size,
                                    },
                                });
                            });

                            if (this.$refs.submitEditorRef) {
                                setTimeout(() => {
                                    this.$refs.submitEditorRef.setHtmlValue(res.data.content); // 手动设置内容数据。（首次加载可能会为空）
                                }, 500);   
                            }
                        }
                    }
                });
            },

            // 获取文件icon
            getFileIcon(fileName) {
                const iconList = {
                    "rar": require("../../assets/icons/zip-icon.svg"),
                    "zip": require("../../assets/icons/zip-icon.svg"),
                    "doc": require("../../assets/icons/doc-icon.svg"),
                    "docx": require("../../assets/icons/doc-icon.svg"),
                    "xls": require("../../assets/icons/xls-icon.svg"),
                    "xlsx": require("../../assets/icons/xls-icon.svg"),
                    "pdf": require("../../assets/icons/pdf-icon.svg"),
                    "jpg": require("../../assets/icons/img-icon.svg"),
                    "png": require("../../assets/icons/img-icon.svg"),
                }
                const fileExtension = fileName?.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
                return iconList[fileExtension] || iconList["jpg"];
            },

            // 开始实训
            handleBeginTraining() {
                if (this.role === 4) {
                    if (this.trainStatus === 1 && this.trainSubmitStatus !== 2) {
                        this.$message.warning("实训已结束");
                        return;
                    }
                }

                const hotVideoTypes = [17, 18, 19, 20, 21, 22, 23, 24]; // 作品数据/非带货短视频
                const shortVideoProducesType = [25, 26, 27]; // 带货短视频数据分析
                const personAccountAnalysisType = [2, 3, 4, 5, 6, 7, 8, 9]; // 个人普通/经营账号数据分析
                const companyAccountAnalysisType = [10, 11, 12, 13, 14]; // 企业账号数据分析
                const douUpDataType = [15, 16]; // dou+投放数据提升

                if (hotVideoTypes.includes(this.project.training_data_type)) {
                    // 作品数据/非带货短视频
                    const routerUrl = this.$router.resolve({ 
                        path: "/training/hotVideo",
                        query: {
                            data_type: this.project.training_data_type,
                        }
                    });
                    window.open(routerUrl.href, "_blank");
                } else if (shortVideoProducesType.includes(this.project.training_data_type)) {
                    // 带货短视频数据分析
                    const routerUrl = this.$router.resolve({ 
                        path: "/training/dsVideo",
                        query: {
                            data_type: this.project.training_data_type,
                        }
                    });
                    window.open(routerUrl.href, "_blank");
                } else if (personAccountAnalysisType.includes(this.project.training_data_type)) {
                    console.log(this.project.training_data_type,"this.project.training_data_type");
                   let routerUrl=""
                    switch (this.project.training_data_type) {
                       
                        case 2:
                            // 数据总览  账号数据分析
                            routerUrl = this.$router.resolve({ 
                                path: "/training/generalView",
                            });
                            break;
                        case 3:
                            // 数据全景分析
                            routerUrl = this.$router.resolve({ 
                                path: "/training/generalView",
                            }); 
                            break;
                        case 4:
                            // 作品数据分析
                            routerUrl = this.$router.resolve({ 
                                path: "/training/dataPanorama",
                            });
                           
                            break;
                        case 5:
                            // 粉丝数据分析
                            routerUrl = this.$router.resolve({ 
                                path: "/training/fansData",
                            });  
                            break;                        
                        case 6:
                            // 经营分析
                            routerUrl = this.$router.resolve({ 
                                path: "/training/generalView",
                            });
                            break;
                        case 7:
                        // 内容分析
                            routerUrl = this.$router.resolve({ 
                                path: "/training/dataPanorama",
                            });
                            break;
                        case 8:
                            // 粉丝分析
                            routerUrl = this.$router.resolve({ 
                                path: "/training/fansData",
                            });
                            break;
                        case 9:
                            // 变现分析
                            routerUrl = this.$router.resolve({ 
                                path: "/training/incomeData",
                            });
                            break;
                }
                window.open(routerUrl.href, "_blank");
                    // 个人普通/经营账号数据分析
                    // /training/accountDataAnalysis
                } else if (companyAccountAnalysisType.includes(this.project.training_data_type)) {
                    // 企业账号数据分析
                    const routerUrl = this.$router.resolve({
                        path: "/training/company",
                        query: {
                            data_type: this.project.training_data_type,
                            project_id: this.project.id,
                        }
                    });
                    window.open(routerUrl.href, "_blank");
                } else if (douUpDataType.includes(this.project.training_data_type)) {
                    // Dou+投放数据提升
                    const routerUrl = this.$router.resolve({ 
                        path: "/training/douIndex",
                        query: {
                            data_type: this.project.training_data_type,
                        }
                    });
                    window.open(routerUrl.href, "_blank");
                }
            },

            // 计算文件大小
            formatFileSize(bytes) {
                if (bytes < 1024) {
                    return bytes + ' B'; // 如果小于 1 KB，直接返回字节数
                } else if (bytes < 1024 * 1024) {
                    return (bytes / 1024).toFixed(2) + ' KB'; // 如果小于 1 MB，返回 KB，并保留两位小数
                } else {
                    return (bytes / (1024 * 1024)).toFixed(2) + ' MB'; // 如果大于等于 1 MB，返回 MB，并保留两位小数
                }
            },

            // 手动上传文件
            trainFileChange(file) {
                const fileRaw = file.raw;

                // 判断文件大小
                const maxSize = 100 * 1024 * 1024; // 文件最大100MB
                if (fileRaw.size > maxSize) {
                    this.$message.warning("文件大小不能超过100MB");
                    return;
                }


                // 判断文件扩展名
                const fileExtension = fileRaw.name.slice(((fileRaw.name.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
                const validExtensions = /^(rar|zip|doc|docx|xls|xlsx|pdf|jpg|png)$/;
                // const validExtensions = /^(rar|zip|docx|xlsx|pdf|jpg|png)$/;
                if (validExtensions.test(fileExtension)) {
                    const formData = new FormData();
                    formData.append("file", fileRaw);

                    this.$shttp.axiosPost(this.$api.training_upload, formData, (res) => {
                        if (res.code === 200) {
                            this.$message.success(res.msg);

                            this.trainFileMap.set(res.data.url, {
                                file: fileRaw,
                                requestData: res.data,
                            });
                            this.$forceUpdate(); // 强制更新
                        } else {
                            this.$message.error(res.msg);
                        }
                    });

                } else {
                    this.$message.warning("文件扩展名仅支持rar、zip、doc、docx、xls、xlsx、pdf、jpg、png");
                    // this.$message.warning("文件扩展名仅支持rar、zip、docx、xlsx、pdf、jpg、png");
                }
            },

            // 删除文件
            deleteSubmitFile(fileItem) {
                const key = fileItem.requestData.url;
                this.trainFileMap.delete(key);

                this.$forceUpdate();
            },

            // 提交实训
            submitTrain() {
                // console.log("submit: ", this.trainFileMap, this.trainContent);
                if (this.trainSubmitStatus === 1) {
                    this.$message.warning("实训已提交，请勿重复提交");
                    return;
                }

                const parser = new DOMParser();
                const doc = parser.parseFromString(this.trainContent, "text/html");

                if (!doc.body.textContent && this.trainContent.length < 12) {
                    this.$message.warning("请输入内容");
                    return;
                }

                const file = [];
                for (let [_, value] of this.trainFileMap) {
                    file.push({
                        url: value.requestData.url,
                        name: value.requestData.name,
                        size: value.file ? this.formatFileSize(value.file.size) : value.requestData.size,
                    });
                }

                const params = {
                    course_id: Number(this.$route.query.course_id),
                    course_chapter: Number(this.$route.query.zhangIndex),
                    course_node: Number(this.$route.query.jieIndex),
                    c_id: Number(localStorage.getItem("c_id")),
                    project_id: Number(this.$route.query.id),
                    content: this.trainContent,
                    file: file,
                };

                this.$shttp.axiosPost(this.$api.training_submit, params, (res) => {
                    if (res.code === 200) {
                        // this.trainFileMap.clear();
                        // this.trainContent = "";
                        this.$message.success(res.msg);

                        this.trainSubmitStatus = 1; // 提交成功不允许重复提交
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
        },
       
    }
</script>

<style scoped lang="scss">
    @import "../material/css/project_info";
    .kechengShixun{
     box-sizing: border-box;
     padding-top: 20px;
    }
</style>